import React from 'react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import PressFeaturedEN from './PressFeaturedEN';
import PressFeaturedFR from './PressFeaturedFR';

import './press-featured-new.less';

@withI18n
class PressFeaturedNew extends React.Component {
  static propTypes = {
    smallLogos: PropTypes.bool,
  };

  render() {
    const {i18n} = this.context;
    const {region} = i18n;
    const {smallLogos} = this.props;

    switch (region) {
    case 'FR':
      return (
        <PressFeaturedFR
          smallLogos={smallLogos} />
      );
    default:
      return (
        <PressFeaturedEN />
      );
    }
  }
}

export default PressFeaturedNew;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/PressFeaturedNew.jsx